
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"9","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8.29.867c.26.243.407.572.407.915 0 .343-.146.673-.408.915L3.7 6.96l4.59 4.262c.133.12.24.262.313.42a1.215 1.215 0 01.009 1.001c-.07.16-.174.304-.304.425-.131.122-.287.218-.458.283a1.49 1.49 0 01-1.078-.009 1.403 1.403 0 01-.453-.29L.742 7.874a1.25 1.25 0 01-.408-.915c0-.343.147-.672.408-.915L6.318.867a1.45 1.45 0 01.986-.379c.37 0 .724.137.985.38z","fill":"#fff"}})])
          )
        }
      }
    